import React from 'react';

import { Heading } from '../../internal/Heading/Heading';
import type { SectionTitleProps } from './types';
import * as styles from './SectionTitle.styles';

export const SectionTitle = ({ headingIsPageTitle, title }: SectionTitleProps) => (
  <Heading css={styles.title} level={headingIsPageTitle ? 1 : 2}>
    {title}
  </Heading>
);
